import XClass from "data-xclass";
import { throttle } from "lodash-es";
import { BaseComponent } from "js/abstracts/baseComponent.js";

import "./accordion.pcss";

class Accordion extends BaseComponent {
    get Defaults() {
        return {
            exclusiveSelector: "[data-accordion-exclusive]",
            panelActiveClass: "accordion-active-panel",
            panelSelector: "[data-accordion-panel]",
            headerSelector: "[data-accordion-header]",
            bodySelector: "[data-accordion-body]"
        };
    }

    constructor(root, options) {
        super(options);

        this.root = root;
        this.exclusive = root.matches(this.options.exclusiveSelector);
        this.on(this.root, "click", this.onClick.bind(this));
        this.updateActivePanels();

        window.addEventListener(
            "resize",
            throttle(() => {
                this.updateActivePanels();
            }, 100)
        );
    }

    onClick(event) {
        const header = event.target.closest(this.options.headerSelector);
        if (!header) {
            return;
        }

        const panel = header.closest(this.options.panelSelector);
        const isActive = panel.classList.contains(this.options.panelActiveClass);
        if (isActive) {
            this.closePanel(panel);
        } else {
            if (this.exclusive) {
                this.root.querySelectorAll(this.options.panelSelector).forEach(otherPanel => {
                    if (otherPanel !== panel) {
                        this.closePanel(otherPanel);
                    }
                });
            }

            const body = panel.querySelector(this.options.bodySelector);
            body.style.maxHeight = body.scrollHeight + "px";
            panel.classList.add(this.options.panelActiveClass);
        }
    }

    closePanel(panel) {
        const body = panel.querySelector(this.options.bodySelector);
        body.style.maxHeight = null;
        panel.classList.remove(this.options.panelActiveClass);
    }

    updateActivePanels() {
        const activePanels = this.root.querySelectorAll(`.${this.options.panelActiveClass}`);
        const activePanelBody = Array.from(activePanels)
            .map(panel => {
                return panel.querySelector(this.options.bodySelector);
            })
            .filter(Boolean);
        const activePanelsBodyScrollHeight = activePanelBody.map(body => {
            return body.scrollHeight;
        });
        window.queueMicrotask(() => {
            activePanelBody.forEach((body, index) => {
                body.style.maxHeight = activePanelsBodyScrollHeight[index] + "px";
            });
        });
    }
}

XClass.register("accordion", {
    init: function (element) {
        element._accordion = new Accordion(element);
    },
    destroy: function (element) {
        element._accordion?.destroy();
        element._accordion = null;
    }
});
